import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

import { EStaticPageName } from '../enums';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      ...Object.values(EStaticPageName).reduce((acc, page) => {
        acc[page] = {
          header: `${page}_HEADER`,
          last_update: `${page}_LAST_UPDATE`,
        };
        return acc;
      }, {} as Record<EStaticPageName, { header: string; last_update: string }>),
    },
    auth: {
      registration: {
        attention_second_part: 'ATTENTION_SECOND_PART',
        attention_last_part: 'ATTENTION_LAST_PART',
        terms: {
          header: 'TERMS.HEADER',
        },
        privacy: {
          header: 'PRIVACY.HEADER',
        },
      },
    },
  }));
}
